export default __webpack_public_path__ + "static/media/satellite-elevation-map-icon.385611cc.png";